import VehicleIndex from "@/views/vehicle/VehicleIndex.vue";

const vehicle = [
    {
        path: '/vehicle',
        name: 'vehicle',
        component: VehicleIndex
    }
]

export default vehicle;